export default [
    '$scope',
    '$routeParams',
    function TagController($scope, $routeParams) {
        $scope.tag = $scope.getTagByTagName($routeParams.tagName);
    }
];
